import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PlatformLayout from "../../components/platform/PlatformLayout";
import { PlatformZones } from "../../components/platform/PlatformZones";

const PlatformHome: React.FC = () => {
 const { t } = useTranslation();

 return (
  <PlatformLayout>
   {/* Dynamically render zones based on stored order */}
   <PlatformZones pageSlug="home" />

   {/* Navigation Links */}
   <section className="py-16 bg-gray-50 border-t">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
     <div className="flex flex-wrap justify-center gap-8">
      <Link to="/how-it-works" className="text-gray-600 hover:text-blue-600 font-medium transition-colors">
       {t("platform.nav.howItWorks") || "How It Works"}
      </Link>
      <Link to="/pricing" className="text-gray-600 hover:text-blue-600 font-medium transition-colors">
       {t("platform.nav.pricing") || "Pricing"}
      </Link>
      <Link to="/policies" className="text-gray-600 hover:text-blue-600 font-medium transition-colors">
       {t("platform.nav.policies") || "Policies"}
      </Link>
      <Link to="/contact" className="text-gray-600 hover:text-blue-600 font-medium transition-colors">
       {t("platform.nav.contact") || "Contact Us"}
      </Link>
     </div>
    </div>
   </section>

  </PlatformLayout>
 );
};

export default PlatformHome;

